define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"csi/reflection",
	"csi/toolbar/MultiSelectSwitchboard",
	"csi/locale",
	"csi/xml"
], function(declare,lang,aspect,reflection,MultiSelectSwitchboard,locale,xml) {

	return declare(MultiSelectSwitchboard, {
		bDelayInitialization: true,
		disableButtonAction: true,
		idViewProperty: "selectedDim2Sizes",
		refreshStoreOptions: true,
		resDefault: "SelectAll",

		// Required
		//switchboardPath: null,

		canShowPlugin: function() {
			// summary: return true to show the switchboard action if the Increment / SizeChartRevision has 2-d SizeRange/ Sizes
			return this.getView()._isTwoDim();
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		postCreate: function() {
			// summary: clear cache and force recalculation of the 2-d Increments matrix spec indices when selection of Dimension2 Sizes on the switchboard changed
			var	view = this.getView();

			this.own(aspect.after(view, "onChangeData", lang.hitch(this, this._onChangeData)));

			view.watch("selectedDim2Sizes", function() {
				view.twoDimSpecIndices = null;
			});

			this.inherited(arguments);
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary : On the Switchboard, Show the Dimension 2 Type in Parenthesis
			var	options = this.inherited(arguments);

			var view = this.getView();
			var ctx = view.getContext();

			var dimension2Type = view.getViewNode().Dimension2Type;
			var typeString = xml.enumGetText(dimension2Type);
			if (typeString != "") {
				typeString = " (" + typeString + ")";
			}

			if (options.data) {
				options.data.forEach(function (d) {
					d.Name += typeString;
				});
			} else {
				options.customOperation = true;
				options.translate = function(sizeNode) {
					return locale.getNodeStoredName(sizeNode, ctx.cache, ctx.locale) + typeString;
				};
			}

			return options;
		},

		_onChangeData: function() {
			this.refreshStore();
		}
	});
});